import React, { Component } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

class AutoScalingDataGrid extends Component {
  constructor(props) {
    super(props);
    this.formatCell = this.formatCell.bind(this);
  }

  formatCell(item) {
    if(item.type.toUpperCase().includes("EMAIL")) {
      return(  <a href={"mailto:" + item.value}>{item.value}</a>);
    }
    else {
      return(item.value);
    }
  }

  render() {
    if(this.props.items !== [] && this.props.columns.length !== undefined)
      return (
        <div>
            {
                this.props.items.map((item, i) => {
                  return (
                    <Grid container spacing={2} className="md-grid--no-spacing" style={{width: "100%"}}key={"row" + i}>
                      <Grid item xs={4} className="contactCell" key={"type" + i}>{item.type}</Grid>
                      <Grid item xs={8} className="contactCell boldText" style={{ paddingLeft: 'var(--padding-10px)' }} key={"value" + i}>{this.formatCell(item)}</Grid>
                    </Grid>);
            })
          }
        </div>
      );
      return null;
  }



}

AutoScalingDataGrid.propTypes = {
  columns: PropTypes.array,
  items: PropTypes.array,
};

export default AutoScalingDataGrid;